import { useEffect } from 'react'
import config from 'configs'
import Smartlook from 'smartlook-client'
import { useStores } from './useStores'

export function useSmartLook(): void {
  const { authStore } = useStores()
  const { userDetail } = authStore

  useEffect(() => {
    if (!config.smartlookAnalyticsKey) {
      return
    }

    // Delay loading Smartlook Analytics until after page load for better performance
    const initSmartlook = () => {
      Smartlook.init(config.smartlookAnalyticsKey, { region: 'eu' })
    }

    // Load Smartlook after page is fully loaded or after a delay
    if (document.readyState === 'complete') {
      setTimeout(initSmartlook, 2000) // 2 second delay
    } else {
      window.addEventListener('load', () => {
        setTimeout(initSmartlook, 2000)
      })
    }
  }, [config.smartlookAnalyticsKey])

  useEffect(() => {
    if (userDetail?.email) {
      Smartlook.identify(userDetail.id, {
        email: userDetail.email,
        name: userDetail.name ?? ''
      })
    }
  }, [userDetail?.email])
}
